import React from 'react';
import Icon from '../../../components/AppIcon';

const LocationTrackingPanel = ({ locations }) => {
  const formatDate = (dateString) => {
    if (!dateString) return 'Unknown';
    const date = new Date(dateString);
    return date?.toLocaleDateString('en-US', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
  };

  return (
    <div className="bg-card rounded-xl border border-border shadow-elevation-1 p-4 md:p-6">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 bg-info/10 rounded-lg flex items-center justify-center">
          <Icon name="MapPin" size={20} color="var(--color-info)" />
        </div>
        <h3 className="text-lg font-heading font-semibold text-foreground">
          Location Tracking
        </h3>
      </div>

      <div className="space-y-3 max-h-96 overflow-y-auto">
        {locations && locations?.length > 0 ? (
          locations?.slice(0, 10)?.map((location) => (
            <div
              key={location?.id}
              className="p-3 bg-muted/30 rounded-lg border border-border hover:bg-muted/50 transition-colors"
            >
              <div className="flex items-start justify-between mb-2">
                <div className="flex-1 min-w-0">
                  <p className="font-medium text-foreground text-sm truncate">
                    {location?.products?.name}
                  </p>
                  <p className="text-xs text-muted-foreground font-mono">
                    {location?.products?.sku}
                  </p>
                </div>
                <span className="text-lg font-semibold text-primary ml-2">
                  {location?.quantity}
                </span>
              </div>
              <div className="flex items-center gap-2 text-xs text-muted-foreground">
                <Icon name="MapPin" size={12} />
                <span>{location?.location_name}</span>
              </div>
              {location?.assigned_technician && (
                <div className="flex items-center gap-2 text-xs text-muted-foreground mt-1">
                  <Icon name="User" size={12} />
                  <span>{location?.assigned_technician}</span>
                </div>
              )}
              <div className="text-xs text-muted-foreground mt-1">
                Updated: {formatDate(location?.last_updated)}
              </div>
            </div>
          ))
        ) : (
          <div className="text-center py-8">
            <Icon name="MapPin" size={32} className="mx-auto mb-2 text-muted-foreground" />
            <p className="text-sm text-muted-foreground">No location data available</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default LocationTrackingPanel;